<template>
  <div>
    <tz-notice />
  </div>
</template>

<script>
// 获取接口地址
import TzNotice from '../components/xxhd/tzgg/tzNotice.vue'

export default {
  name: 'Tzgg',
  components: {
    TzNotice
    // sideMenu,
    // Header
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
